import React from "react";

const MerchantDetails = (props) => {
  const merchant = props.impersonation.merchantDetails;
  const isTrialMerchant = typeof merchant.activation_link === "string";

  // traverse the merchant salseslocations and extract acquirer mids
  let acquirer_mid_pairs = [];
  merchant.saleslocation_set.forEach((s) => {
    const acquirer_mids = s.mid_set.map((m) => {
      return {
        acquirer: m.acquirer,
        mid: m.mid,
      };
    });
    acquirer_mid_pairs = acquirer_mid_pairs.concat(acquirer_mids);
  });

  const merchantSource = props.impersonation.merchantSource;

  const parseAddress = (address) => {
    return address ? `${address.street_address}, ${address.city} ${address.postal_code}, ${address.country}` : null;
  };

  return (
    <div className="merchant-details">
      <h1>{merchant.name}</h1>
      {isTrialMerchant ? (
        <div>
          <span className="trial-merchant">Test Merchant</span>
        </div>
      ) : null}
      <div className="merchant-details-list">
        <dl>
          <dt>Merchant ID</dt>
          <dd>
            <code>{merchant.id}</code>
          </dd>
        </dl>
        {merchantSource && (
          <React.Fragment>
            <dl>
              <dt>Source</dt>
              <dd>{merchantSource.source}</dd>
            </dl>
            <dl>
              <dt>Source ID</dt>
              <dd>
                <code>{merchantSource.source_id}</code>
              </dd>
            </dl>
          </React.Fragment>
        )}
        <dl>
          <dt>Org. number</dt>
          <dd>{merchant.number}</dd>
        </dl>
        <dl>
          <dt>Partner ID</dt>
          <dd>{merchant.source_partner_id || "-"}</dd>
        </dl>
        <dl>
          <dt>Billing address</dt>
          <dd>{parseAddress(merchant.billing_address)}</dd>
        </dl>
        <dl>
          <dt>Phone</dt>
          <dd>
            <a href={"tel:" + merchant.phone}>{merchant.phone}</a>
          </dd>
        </dl>
      </div>
    </div>
  );
};

export default MerchantDetails;
